import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { PublisherComponent } from './videoapp/components/publisher/publisher.component';
import { SubscriberComponent } from './videoapp/components/subscriber/subscriber.component';
import { OpentokService } from './opentok.service';
import { VideoAppComponent } from './videoapp/videoapp.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DeviceselectorComponent } from './videoapp/components/deviceselector/deviceselector.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ChatComponent } from './videoapp/components/chat/chat.component';
import { DatashareService } from './services/datashare.service';
import { VideoEndedComponent } from './videoapp/component/video-ended/video-ended.component';

const modules = [
  MatDialogModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatSelectModule
];

@NgModule({
imports: [...modules],
exports: [...modules],
declarations: [VideoEndedComponent]
,
})export class MaterialModule {};

@NgModule({
  declarations: [
    AppComponent,
    VideoAppComponent,
    PublisherComponent,
    SubscriberComponent,
    DeviceselectorComponent,
    ChatComponent
  ],
  entryComponents: [
    DeviceselectorComponent
  ], 
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule
  ],
  providers: [OpentokService, DatashareService],
  bootstrap: [AppComponent]
})
export class AppModule { }
 